export default __webpack_public_path__ + "static/media/cfjp05.e0d97772.png";